import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a5bdd17"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 1,
  class: "description"
}

import { ref } from 'vue'
import { useDoubleClickListener } from '../../composables/useDoubleClickListener'


export default /*#__PURE__*/_defineComponent({
  props: {
  imageSrc: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  description: {
    type: String,
    default: undefined,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: undefined,
  },
  iconClass: {
    type: String,
    default: undefined,
  },
  iconSize: {
    type: [String, Number],
    default: 18,
  },
  backgroundColor: {
    type: String,
    default: 'grey-lighter',
  },
},
  emits: ['click', 'double-click'],
  setup(__props, { emit }) {


const card = ref<HTMLDivElement>()

const isHoveredOver = ref(false)

useDoubleClickListener(card, () => {
  emit('double-click')
})



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_context_menu = _resolveComponent("c-context-menu")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "card",
    ref: card,
    class: "c-small-card",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHoveredOver.value = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHoveredOver.value = false)),
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["content flex items-center justify-center", [
        `bg-${__props.backgroundColor}`,
        __props.selected ? 'is-selected' : ''
      ]])
    }, [
      (__props.imageSrc)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.imageSrc,
            class: "image"
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            name: __props.icon,
            style: _normalizeStyle(`font-size: ${__props.iconSize}px`),
            class: _normalizeClass(__props.iconClass)
          }, null, 8, ["name", "style", "class"])),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.$slots['context-menu-items'])
            ? _withDirectives((_openBlock(), _createBlock(_component_c_context_menu, {
                key: 0,
                class: "absolute right-0 top-0",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "context-menu-items")
                ]),
                _: 3
              }, 512)), [
                [_vShow, isHoveredOver.value]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ], 2),
    (__props.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["text mt-8px line-clamp-2 break-words", { 'font-semibold': __props.selected }]),
          title: __props.text
        }, _toDisplayString(__props.text), 11, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true)
  ], 544))
}
}

})